import { PricingPlansSection } from "../pricingPlans";
import { PricingPlanProps } from "../pricingPlans/card";

const plans: PricingPlanProps[] = [
  {
    name: "Basic",
    priceMonthly: "19",
    features: [
      { text: "Payroll Calculation for Salaried & Hourly Employees" },
      {
        text: "Templated, Compliant Employment Contracts",
      },
      { text: "Labor Compliance Guidance for Adding New Team Members" },
      { text: "Time Tracking", comingSoon: true },
    ],
    available: true,
  },
  {
    name: "Plus",
    priceMonthly: "24",
    features: [
      { text: "Everything in Basic" },
      {
        text: "Access to SafetyWing Medical, Dental, and Vision Insurance for Your Employees",
      },
      { text: "Labor Benefit Fund Administration" },
    ],
    available: false,
  },
];

type SubscriptionPricingPlansProps = {
  selectedPricingPlan: number;
  setSelectedPricingPlan: React.Dispatch<React.SetStateAction<number>>;
};

export const SubscriptionPricingPlans = ({
  selectedPricingPlan,
  setSelectedPricingPlan,
}: SubscriptionPricingPlansProps) => (
  <PricingPlansSection
    {...{ plans, selectedPricingPlan, setSelectedPricingPlan }}
  />
);
